var React = require('react');

function Paint (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8C22 9.32608 21.4732 10.5979 20.5355 11.5355C19.5979 12.4732 18.3261 13 17 13H12V15M7 3H17C18.1046 3 19 3.89543 19 5V7C19 8.10457 18.1046 9 17 9H7C5.89543 9 5 8.10457 5 7V5C5 3.89543 5.89543 3 7 3ZM11 15H13C13.5523 15 14 15.4477 14 16V20C14 20.5523 13.5523 21 13 21H11C10.4477 21 10 20.5523 10 20V16C10 15.4477 10.4477 15 11 15Z","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Paint.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Paint;

Paint.default = Paint;
